import cx from 'classnames';
import { ProductCardTitleProps } from '../types';
import styles from '../Product.module.scss';

export const ProductCardTextEllipsis = ({
  children,
  className
}: ProductCardTitleProps) => {
  return (
    <div className={cx(styles['product-comparison__card-ellipsis'], className)}>
      {children}
    </div>
  );
};
